var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDRed4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50 2.5C23.808 2.5 2.5 23.808 2.5 50S23.808 97.5 50 97.5 97.5 76.192 97.5 50 76.192 2.5 50 2.5zm28.834 76.114c-3.642-7.49-11.32-12.66-20.206-12.66H41.372c-8.885 0-16.564 5.17-20.206 12.66C13.871 71.263 9.356 61.15 9.356 50 9.356 27.589 27.589 9.356 50 9.356S90.644 27.589 90.644 50c0 11.15-4.515 21.263-11.81 28.614z",
    fill: "#c399a3",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40.869,
    r: 18.263,
    fill: "#c399a3",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDRed4);
export default __webpack_public_path__ + "static/media/user-d-red4.5c2ca91cfeb56eb623f78912e4a2d57f.svg";
export { ForwardRef as ReactComponent };